var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('div',{staticClass:"calculators"},[_c('CarCalculator',{attrs:{"is-holiday":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }